var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/991249baa5074badb26bf70b1b264797.js').default;export default
        Object.assign({}, scope_0 )
    